import React, { useState, useEffect } from 'react';

export default function ModalSucursales({sucursales, sucursal, seleccionaSucursal, closeModal}){

    const [sucursalId, setSucursalId] = useState();
    const [mensaje, setMensaje] = useState('');

    useEffect(()=>{
        setSucursalId(sucursal.id) 
    },[]);

    function EligeSucursal(){
        setMensaje('');
      
        if (sucursalId===undefined){
            setMensaje("Seleccione sucursal!");
            return;
        }
        console.log(sucursales)
        console.log(sucursalId)
        let suc_ = sucursales.find(sucursal => sucursal.id === parseInt(sucursalId))
        seleccionaSucursal(suc_)
        closeModal();
    }

return (
    <div>
        <div className="row">
              <div className="col-md-12 d-flex justify-content-end">
                  <button type="button" id="btn-guardar" onClick={closeModal} class="btn btn-info"><i class="bi bi-x-circle"></i> </button>     
              </div>
        </div>
        <div className='row'>
            <div className='col-md-12 d-flex justify-content-center'>
                <label>Seleccione sucursal!</label>
            </div>
        </div>
        <div className='row'>
            <div className='col-md-12 d-flex justify-content-center'>
                <label>{mensaje}</label>
            </div>
        </div>
        
        <div className='row'>
            <div className='col-md-12'>
                <select className='form-control'value={sucursalId} onChange={(ev)=>setSucursalId(ev.target.value)}>
             {sucursales.map(sucursal =>
                        <option value={sucursal.id}> {sucursal.nombre} </option>)
                    }
                </select>                              
            </div>
        </div>
        <br></br>
        <div className='row'>
            <div className='col-md-12 d-flex justify-content-center'>
                <button className='btn  btn-secondary ' onClick={EligeSucursal}>Continuar</button>
            </div>
        </div>
    </div>);
};


                